import { HttpStatusCode } from "../../../../common/infra/http-status/http-status";
import { BackedApi } from "../../../../config/urls/Api";
import { Action } from "../../application/domain/actions";


interface ResponseActions {
    data: {
        workout: string;
        actions: Action[];        
    }
    error: boolean;
    status: number;
}
export class ActionsRepository {
    static async list(workoutId: string): Promise<ResponseActions> {    
        const response = await this.sendRequest(
            BackedApi.ListActions(workoutId).url,
            BackedApi.ListDrills.method,            
        )
        const data = await response.json();
        const status = response.status;
        return { data, error: status !== HttpStatusCode.OK, status };
    }

    static async create(action: Action): Promise<ResponseActions> {
        const response = await this.sendRequest(
            BackedApi.CreateAction.url,
            BackedApi.CreateAction.method,
            action
        )
        const data = await response.json();
        const status = response.status;
        return { data, error: status !== HttpStatusCode.CREATED, status };
    }

    private static async sendRequest(url: string, method: string, body?: any) {
        const response = await fetch(url, {
            method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            ...(body && { body: JSON.stringify(body) }),            
        })
        return response;
    }
}